export const PERK_CONFIG = {
  PERKS_PER_PAGE: 9,
} as const;

export const ROLE_CONFIG = {
  ROLES_PER_PAGE: 9,
} as const;
